import { LuMenu } from "react-icons/lu";
import {
  useIsSideMenuOpen,
  useSideMenuActions,
} from "../../view_stores/useSideMenuStore";

export function SideMenuIcon() {
  const { open: openSideMenu, close: closeSideMenu } = useSideMenuActions();
  const isSideMenuOpen = useIsSideMenuOpen();

  return (
    <LuMenu
      size={34}
      onClick={isSideMenuOpen ? closeSideMenu : openSideMenu}
      className="cursor-pointer text-light-text dark:text-dark-text"
    />
  );
}
